import { useState, useEffect } from 'react';

export default function SponsorsSection() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const sponsors = [
    'https://tristatewarriors.com/wp-content/uploads/2024/02/SPONSORS-4.png',
    'https://tristatewarriors.com/wp-content/uploads/2024/02/SPONSORS-3.png',
    'https://tristatewarriors.com/wp-content/uploads/2024/02/SPONSORS-2.png',
    'https://tristatewarriors.com/wp-content/uploads/2024/02/SPONSORS-1.png',
    'https://tristatewarriors.com/wp-content/uploads/2024/03/SPORFIE-2.png',
    'https://tristatewarriors.com/wp-content/uploads/2024/03/PDF-SPORTS.png',
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % sponsors.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [sponsors.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % sponsors.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + sponsors.length) % sponsors.length);
  };

  return (
    <div className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-black text-gray-900 mb-4">SPONSORS</h2>
          <p className="text-lg text-gray-600">
            Thank you to our amazing sponsors who make it all possible
          </p>
        </div>

        {/* Sponsors Slider */}
        <div className="relative max-w-4xl mx-auto">
          <div className="overflow-hidden rounded-2xl bg-gray-50 p-12">
            <div className="relative h-48 flex items-center justify-center">
              {sponsors.map((sponsor, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 flex items-center justify-center transition-all duration-500 ${
                    index === currentSlide
                      ? 'opacity-100 scale-100'
                      : 'opacity-0 scale-95'
                  }`}
                >
                  <img
                    src={sponsor}
                    alt={`Sponsor ${index + 1}`}
                    className="max-h-40 w-auto object-contain"
                  />
                </div>
              ))}
            </div>
          </div>

          {/* Navigation Buttons */}
          <button
            onClick={prevSlide}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 bg-white rounded-full p-3 shadow-lg hover:bg-gray-100 transition-colors cursor-pointer"
            aria-label="Previous sponsor"
          >
            <i className="ri-arrow-left-line text-2xl text-gray-900"></i>
          </button>
          <button
            onClick={nextSlide}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 bg-white rounded-full p-3 shadow-lg hover:bg-gray-100 transition-colors cursor-pointer"
            aria-label="Next sponsor"
          >
            <i className="ri-arrow-right-line text-2xl text-gray-900"></i>
          </button>

          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mt-8">
            {sponsors.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === currentSlide
                    ? 'bg-red-600 w-8'
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
                aria-label={`Go to sponsor ${index + 1}`}
              />
            ))}
          </div>
        </div>

        {/* Become a Sponsor CTA */}
        <div className="text-center mt-16">
          <a
            href="#sponsor"
            className="inline-block bg-red-600 text-white px-8 py-4 rounded-lg text-base font-bold hover:bg-red-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Become a Sponsor
          </a>
        </div>
      </div>
    </div>
  );
}
